export const ALERT_DIALOG = 'ALERT_DIALOG';
export const CONFIRM_DIALOG = 'CONFIRM_DIALOG';


// WEBPACK FOOTER //
// ./src/actions/dialog/types.js